import type { RutaProd } from '../../../../runtime/rutas';
export default { ruta: '/sistema/__spike/invoices', documento: 'invoices', acceso: 'sesion', filas: [], cita: 'PANTALLAS-PLAN.md §4.2: arnés local para _Receiver y Reports/#DateRange' } satisfies RutaProd;
